module.exports = __webpack_public_path__ + "img/27.393c011e.png";